class InfiniteScroll extends HTMLElement {
    constructor() {
        super();
        this.initGrid();
        this.page = 1;
        this.productsLoaded = parseInt(this.dataset.pagination);
        this.totalProducts = parseInt(this.dataset.totalProducts);
        this.loadMoreBtn = document.getElementById('load-more-btn');
        this.loadMoreBtn.addEventListener('click', this.loadMoreProducts.bind(this));
        this.countTemplate = this.dataset.countTemplate;
        this.updateProductCountMessage();
    }

    initGrid() {
        const gridOptions = ['.ProductListWrapper', '#main-collection-product-grid', '#product-grid', '.product-list'];
        for (let gridName of gridOptions) {
            let grid = document.querySelector(gridName);
            if (grid) {
                this.gridName = gridName;
                this.gridContainer = grid;
                break;
            }
        }
    }

    loadMoreProducts() {
        this.page++;
        this.fetchNextPage(this.page);
    }

    fetchNextPage(page) {
        const nextUrl = new URL(this.dataset.next, this.dataset.shopUrl);

        fetch(nextUrl.href, { method: 'GET', headers: { 'Content-Type': 'text/html' } })
            .then((response) => {
                if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
                return response.text();
            })
            .then((data) => {
                const parsedHTML = new DOMParser().parseFromString(data, 'text/html');
                const newItems = Array.from(parsedHTML.querySelector(this.gridName).children);

                newItems.forEach((item) => {
                    this.gridContainer.insertAdjacentHTML('beforeend', item.outerHTML);

                    if (!item.classList.contains('grid-item-double')) {
                        this.productsLoaded++;
                    }
                });

                this.updateProductCountMessage();

                const newInfiniteScroll = parsedHTML.querySelector('infinite-scroll');
                if (newInfiniteScroll && newInfiniteScroll.dataset.next) {
                    this.dataset.next = newInfiniteScroll.dataset.next;
                } else {
                    this.loadMoreBtn.style.display = 'none';
                }
            })
            .catch((error) => console.error('Error:', error));
    }

    updateProductCountMessage() {
        const messageElement = document.getElementById('product-count-message');
        if (this.countTemplate) {
            const message = this.countTemplate
                .replace('{productsLoaded}', this.productsLoaded)
                .replace('{totalProducts}', this.totalProducts);
            messageElement.textContent = message;
        } else {
            console.error('countTemplate is undefined.');
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    customElements.define('infinite-scroll', InfiniteScroll);
});
